import { FormattedMessage } from 'react-intl';

import messages from './ProductDownloads.messages';

const ProductDownloadsMobile = () => {
  return (
    <div className="flex flex-col items-center col-span-full space-y-2 text-center">
      <svg
        width="65"
        height="64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fillRule="evenodd" clipRule="evenodd">
          <path
            d="M32.504 56.008c13.257 0 24.004-10.747 24.004-24.004C56.508 18.747 45.761 8 32.504 8 19.247 8 8.5 18.747 8.5 32.004c0 13.257 10.747 24.004 24.004 24.004Z"
            fill="#12B362"
          />
          <path
            d="m21.793 34.425 9.436 9.436 1.415 1.414 1.414-1.414 9.436-9.436-2.828-2.829-6.026 6.026V21.001h-4v16.614l-6.019-6.019-2.828 2.829Z"
            fill="#fff"
          />
        </g>
      </svg>
      <h1 className="webex-h4">
        <FormattedMessage {...messages.title} />
      </h1>
      <p>
        <FormattedMessage {...messages.mobileAccess} />
      </p>
    </div>
  );
};

export default ProductDownloadsMobile;
